import React, { Component } from 'react';

class Header extends Component {	

	shouldComponetUpdate(nextProps, nextState) {
		return false;

	}
	render () {
		return (
			<div>
				<h1 >Escape Team!</h1>
				<div>Rooms played: {this.props.roomplayed}</div>
			</div>	
		)
	}
}

export default Header


// WEBPACK FOOTER //
// ./src/Components/Header.js